import React, { useState } from 'react';
import { API_BASE_URL } from "../../constants";
import { request } from "../../util/APIUtils";
import { message } from "antd";

const DutyRosterDeleteModal = ({ selectedRoster, cancelProcess }) => {
    const [loading, setLoading] = useState(false);

    const handleDelete = () => {
        const rosterId = (selectedRoster && selectedRoster.rosterId)
            ? selectedRoster.rosterId
            : (selectedRoster && selectedRoster.id ? selectedRoster.id : null);

        if (!selectedRoster || !rosterId) {
            message.error("Silinecek nöbet listesi bulunamadı.");
            return;
        }

        setLoading(true);
        request({
            url: `${API_BASE_URL}/duty-rosters/${rosterId}`,
            method: "DELETE",
        })
            .then(() => {
                message.success("Nöbet listesi silindi.");
                cancelProcess();
            })
            .catch(() => {
                message.error("Silme işlemi başarısız oldu.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const regionName =
        selectedRoster && selectedRoster.regionName
            ? selectedRoster.regionName
            : "belirtilmemiş";
    const dutyDate =
        selectedRoster && selectedRoster.dutyDate
            ? selectedRoster.dutyDate.split('T')[0]
            : "belirtilmemiş";

    return (
        <div>
            <p>
                {regionName} bölgesi {dutyDate} tarihine ait nöbet listesi silinecek. Emin misiniz?
            </p>
            <button className="cancel" onClick={cancelProcess} disabled={loading}>
                İptal
            </button>
            <button
                className="save"
                onClick={handleDelete}
                disabled={loading}
            >
                {loading ? "Siliniyor..." : "Sil"}
            </button>
        </div>
    );
};

export default DutyRosterDeleteModal;



// WEBPACK FOOTER //
// ./src/page/dutyRoster/DutyRosterDeleteModal.js